import axios from 'axios';

/**
 * Obtiene el ISSUE_TIMESTAMP de una capa activa en el servidor WFS
 * utilizando el backend que implementa fallback automático (Cloud → AIMethods).
 *
 * @param {string} selectedDate - Fecha seleccionada en formato UTC.
 * @param {function} setForecastValue - Función para actualizar el valor del forecast.
 * @param {string} activeLayer - Nombre completo de la capa (ej: "ICE:ICE_025_live_demo").
 * @param {AbortSignal} signal - Signal opcional para cancelar la petición.
 */
const ForecastRelease = async (selectedDate, setForecastValue, activeLayer, signal = null) => {
  try {
    // Evitar bugs por espacios en blanco en los nombres de las capas 
    const layerName = activeLayer.trim();

    // 1Determinamos si es una capa "live" + excepocion para euro1k
    const isLive = layerName.toLowerCase().includes('live') || layerName.includes('euro_1k');

    // Construimos la URL
    let url;
    if (isLive) {
      // Por defecto, todas las capas "live" van por el proxy normal
      let baseUrl = `${process.env.REACT_APP_API_URL}/proxy/wfs`;

      // Excepción colo va a /cloud (AWS) si empieza por CNN Y NO es la capa euro_1k
      if (layerName.startsWith('CNN') && layerName !== 'CNN:euro_1k_00625_15m') {
        baseUrl = `${process.env.REACT_APP_API_URL}/proxy/wfs/cloud`;
      }

      url = baseUrl +
            `?service=WFS&version=1.0.0&request=GetFeature` +
            `&typeName=${layerName}` +
            `&outputFormat=application/json` +
            `&propertyName=ISSUE_TIMESTAMP&sortBy=ISSUE_TIMESTAMP+D` +
            `&maxFeatures=1`;

            
    } else {
      // HISTORICAL
      const workspace = layerName.split(':')[0];
      url = `${process.env.REACT_APP_API_URL}/proxy/forecast-release/${workspace}` +
            `?service=WFS&version=1.0.0&request=GetFeature` +
            `&typeName=${layerName}` +
            `&outputFormat=application/json` +
            `&propertyName=ISSUE_TIMESTAMP&maxFeatures=1`;

      const CQL_FILTER = `ISSUE_TIMESTAMP<'${selectedDate}' OR ISSUE_TIMESTAMP>'${selectedDate}'`;
      url += `&CQL_FILTER=${encodeURIComponent(CQL_FILTER)}&sortBy=ISSUE_TIMESTAMP`;
    }

    // 3️⃣ Hacemos la petición al backend
    const resp = await axios.get(url, { signal });
    const features = resp.data?.features;

    // 4️⃣ Procesamos la respuesta
    if (features && features.length > 0) {
      const issueTimestamp = features[0].properties.ISSUE_TIMESTAMP;
      setForecastValue(issueTimestamp);
    } else {
      console.warn(`No data found for active layer: ${layerName}`);
      setForecastValue(null);
    }
  } catch (error) {
    if (axios.isCancel(error) || error.name === 'AbortError') return; 
    console.error(`Error fetching forecast release for ${activeLayer}:`, error.message);
    setForecastValue(null);
  }
};

export default ForecastRelease;